import { Button, CircularProgress, Divider, Grid, Paper, Typography } from '@material-ui/core';
import React, { useEffect } from 'react';
import Chart from "react-google-charts";
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { useAppSelector } from '../../app/hooks';
import { getProjectDetails, getFanDetails, getFanData, getFetching, getFetchingError, createNewProject, getDrafts, getProjects } from '../../app/reducer/project.reducer';
import { ENCON_LOGO } from '../../assets';
import { searchFunction1, searchFunction3, searchFunction4 } from '../general/utils';

function getBaseLog(x: number, y: number): number {
  return Math.log(y) / Math.log(x);
}

let options = { year: 'numeric', month: 'long', day: 'numeric' };

export default function Page1() {

  const dispatch = useDispatch();
  const history = useHistory();

  const [openErrAlert, setOpenErrAlert] = React.useState<boolean>(false);

  const projectDetails = useAppSelector(getProjectDetails)||{};
  const fanDetails = useAppSelector(getFanDetails);
  const fan = useAppSelector(getFanData);
  const projBusy = useAppSelector(getFetching);
  const fetchingErr = useAppSelector(getFetchingError);

  let projectDate: any;
  console.log("fandetails2", fanDetails, projectDetails)
  if (projectDetails.updatedAt) {
    projectDate = new Date(projectDetails.updatedAt + "");
  } else {
    projectDate = new Date();
  }
  const d1 = fanDetails.fan_diameter ? parseFloat(fanDetails.fan_diameter) : fan.fanDiameter;
  console.log(typeof d1)
  
  const d3 = fan.fanModelID;
  const d4 = fanDetails.blade_no ? fanDetails.blade_no : fan.numofBlades;

  const d5 = fanDetails.application;
  const d6 = fanDetails.mounting_orientation;
  const d7 = fanDetails.install_type;
  const d9 = fanDetails.set_no;

  const d10 = fanDetails.atmosphere_type;
  const d11 = fanDetails.rh;
  const d12 = fanDetails.altitude;
  const d13 = fanDetails.barometric_pressure;
  const d14 = fanDetails.inlet_temp;
  const d15 = fanDetails.minimum;
  const d16 = fanDetails.maximum;
  const d17 = fanDetails.air_density?fanDetails.air_density:((((101325 * Math.exp((-9.80665 * 0.028964 * (fanDetails.altitude - 0)) / (8.31432 * ((fanDetails.minimum - 0) + 273)))) - ((6.1078 * (10 ^ ((7.5 * (fanDetails.minimum - 0)) / ((fanDetails.minimum - 0) + 237.3)))) * (fanDetails.rh - 0))) / (287.058 * ((fanDetails.minimum - 0) + 273))) + (((6.1078 * (10 ^ ((7.5 * (fanDetails.minimum - 0)) / ((fanDetails.minimum - 0) + 237.3)))) * (fanDetails.rh - 0)) / (461.495 * ((fanDetails.minimum - 0) + 273))));
  const d18 = ((((101325 * Math.exp((-9.80665 * 0.028964 * (fanDetails.altitude - 0)) / (8.31432 * ((fanDetails.minimum - 0) + 273)))) - ((6.1078 * (10 ^ ((7.5 * (fanDetails.minimum - 0)) / ((fanDetails.minimum - 0) + 237.3)))) * (fanDetails.rh - 0))) / (287.058 * ((fanDetails.minimum - 0) + 273))) + (((6.1078 * (10 ^ ((7.5 * (fanDetails.minimum - 0)) / ((fanDetails.minimum - 0) + 237.3)))) * (fanDetails.rh - 0)) / (461.495 * ((fanDetails.minimum - 0) + 273))));
  const d19 = ((((101325 * Math.exp((-9.80665 * 0.028964 * (fanDetails.altitude - 0)) / (8.31432 * ((fanDetails.maximum - 0) + 273)))) - ((6.1078 * (10 ^ ((7.5 * (fanDetails.maximum - 0)) / ((fanDetails.maximum - 0) + 237.3)))) * (fanDetails.rh - 0))) / (287.058 * ((fanDetails.maximum - 0) + 273))) + (((6.1078 * (10 ^ ((7.5 * (fanDetails.maximum - 0)) / ((fanDetails.maximum - 0) + 237.3)))) * (fanDetails.rh - 0)) / (461.495 * ((fanDetails.maximum - 0) + 273))));
  const d20 = fan.bladeModel.bladeModelID;
  //const d23 = ((d2-d1)*500);
  const d23 = fanDetails.fan_ring_diameter ? ((fanDetails.fan_ring_diameter - fan.fanDiameter)*1000 / 2) : (0.0045 * 1000 * fan.fanDiameter);
  const d2 = fanDetails.fan_ring_diameter ? fanDetails.fan_ring_diameter : (d1 + (d1 * 2 * 0.0045))?.toFixed(3);  // replace with fan casing diameter incase user hasnt input anything
  console.log(d2, typeof d2,fanDetails.fan_ring_diameter);
  const d24 = fanDetails.inlet_type;
  const d25 = fanDetails.venturi_height;
  const d26 = fanDetails.angle;
  const d27 = fanDetails.lnd;
  const d28 = fanDetails.beam_no;
  const d29 = fanDetails.motor_rating;
  const d30 = fanDetails.motor_rpm;

  const d31 = 3.14 * (Math.pow(d2, 2) - Math.pow(fan.hub.hubDiameter, 2)) / 4;
  console.log(d2, Math.pow(d2, 2), Math.pow(fan.hub.hubDiameter, 2), d31)
  const d32 = fanDetails.motor_eff;
  const d33 = fanDetails.transmission_efficiency;

  const d34 = fanDetails.req_airflow
  console.log(d34)
  let d35: any = null;
  let d38: any = null;

  const d46 = d34 / d31;
  console.log('--test-2-', fanDetails);

  const d36: any = 0.5 * d17 * Math.pow(d46, 2);
  const d37: any = d36 - (0.5 * d17 * (Math.pow(d34 / (3.14 * (fanDetails.discharge_dia ?? 1) * (fanDetails.discharge_dia ?? 1) / 4), 2)) * (fanDetails.diffuser_eff ?? 1) / 100);

  if (fanDetails.pressure_type === "static") { //CHECK
    d38 = (parseFloat(fanDetails.pressure) + parseFloat(d36) - (isNaN(d37) ? 0 : d37));
    //d38 = (fanDetails.pressure + d36 - d37);
    // d35 = (parseFloat(fanDetails.pressure) - parseFloat(d36) + (isNaN(d37)?0:d37));
    d35 = parseFloat(fanDetails?.pressure);

  } else {
    d38 = parseFloat(fanDetails?.pressure);
    // d35 = (fanDetails.pressure - (isNaN(d37)?0:d37));
    d35 = (parseFloat(fanDetails.pressure) - parseFloat(d36) + (isNaN(d37) ? 0 : d37));
  }



  const d45 = fan.designPoint?.expectedEfficiency;

  const d39 = d34 * d38 * 0.1 / d45; // d34- req AF , d38 -> pressure d45-> Expected Efficiency
  const d40 = d39 * d18 / d17;
  const d40_1 = d39 * d19 / d17;
  const d42 = ((5.192 * (d38 / (9.807 * 25.4)) * (((22 / 7) / 4) * (Math.pow((d1 / 0.3048), 2))) / 2.202));
  //const d44 = d34 * d35 / (1000* d39) ;
  const d44 = d34 * d35 / (10 * d39);

  const d47 = searchFunction3(fan.performance_curves, fanDetails.req_airflow, fanDetails.fan_speed?fanDetails.fan_speed:fan.rpm, fan.rpm, d17, 1.2, d31, fanDetails.pressure_type === 'static', fanDetails.pressure);
  console.log(d47)
  // const d48 = searchFunction4(fan.performance_curves,fanDetails.pressure) ;

  const d49 = fanDetails.fan_speed ? fanDetails.fan_speed : fan.rpm;

  const d41 = (4500 * ((d39 / 0.745) / (2 * 3.14 * d49))); // d49 -> fan_speed
  console.log("Datasheet", d34, d38, d41, d49, d39)
  const d50 = d1 * d49 * (22 / 7) / 60;
  const d51 = fan.designPoint.expectedAngle//fan.bladeModel.tipAngleDeviation ;
  const d52 = fan.bladeModel.bladeMinAngle;
  const d52_1 = fan.bladeModel.bladeMaxAngle;
  const d53 = (d4 * fan.bladeModel.bladeWeight) + fan.hub.hubWeight;

  const d43 = d42 + d53;

  const d54 = fan.bladeModel.bladeMaterial;
  const d55 = fan.hub.hubMaterial;

  const d56 = "";
  const d57 = d39 / d4;

  const d59 = d53 * (((1 / 3) * (d1 / 2)) * ((1 / 3) * (d1 / 2)));
  // const d58 = (((d41*7.329*5880)/(Math.pow(d49,2)))*4.87) ;// formula changed to 4 times of d59
  const d58 = d59 * 4;
  const permissible_unbalance = fan.hub.hubDetails >= 100 ? 200 : 100;
  const testing_speed = fan.hub.hubDetails >= 100 ? 300 : 600;
  const d60 = ((((permissible_unbalance * testing_speed / d49) / 2) * fan.hub.hubWeight / (fan.hub.hubDiameter * 1000 / 2)) / 1000) * (d1 * fanDetails.blade_cog_ratio) * ((d49 * (3.14 / 30)) ** 2);
  const d61 = (d53 * (d1 * 0.25)) * ((d49 * (3.14 / 30)) ^ 2);

  const d62 = fan.bladeModel.bladeFreqMode1;
  console.log((Math.pow(d62, 2)), (1.5 * d49 / 60));
  const d63 = (Math.sqrt(Math.pow(d62, 2) + (1.5 * d49 / 60)));
  const d64 = (d49 * d4) / 60;
  // console.log()
  const d65 = d49 * d28 / 60;
  const d66 = d49 / 60;

  const d67 = ((d64 - d63) * 100) / d64;
  // const d67 = ((Math.sqrt(Math.pow((fan.bladeModel.bladeFreqMode2),2)+(1.5*(fanDetails.fan_rpm?fanDetails.fan_rpm:fan.rpm)/60)))-((fanDetails.fan_rpm?fanDetails.fan_rpm:fan.rpm)/ 60))%(Math.sqrt(Math.pow((fan.bladeModel.bladeFreqMode2),2)+(1.5*(fanDetails.fan_rpm?fanDetails.fan_rpm:fan.rpm)/60))) ;
  const d68 = "ISO 10816 - 1 / G-6.3";
  const d69 = "ISO 1940 / 1";
  const d70 = d39 * 10000 / (d32 * d33);
  const d71 = "";

  const d72 = (55 + 30 * Math.log((3.14 * d1 * d49 / 0.3048) / 1000) + 10 * getBaseLog((d39 / 0.75), 10) - 5 * getBaseLog((d1 / 0.3048), 10)) + fanDetails.sound_power_cf;
  const d73 = (d72 - 2 - 10 * Math.log(2 * 3.14 * ((d2 / 2) + 1) ^ 2) - (2 - 6.8 * (1 - Math.sqrt(1 / ((d2 / 2) + 1)))));
  const d74 = (d72 - 2 - 10 * Math.log(2 * 3.14) - (2 - 6.8 * (1 - (Math.sqrt(Math.cos(45))))));


  return (
    <Paper className="datasheet-paper" id="datasheet-page1" style={{ width: '100%', padding: '40px' }}>
      <div className="datasheet-row">
        <div>
          <img src={ENCON_LOGO} style={{ height: '200px', width: '200px' }} />
        </div>
        <div style={{ fontSize:'23px', flex: 1, textAlign: 'center' }}>
          <Typography variant="h2">
            <b>ENCON GROUP</b>
          </Typography>
          <Typography variant="h4">
            FAN TECHNICAL DATA
          </Typography>
        </div>
      </div>
      <hr />

      <div className="datasheet-row light-gray">
        <Grid container spacing={3}>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Project Name:
              </div>
              <div style={{ fontSize:'23px'}}>
                {projectDetails.project}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Customer:
              </div>
              <div style={{ fontSize:'23px'}}>
                {projectDetails.consultant}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Location:
              </div>
              <div style={{ fontSize:'23px'}}>
                {projectDetails.location}
              </div>
            </div>
          </Grid>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Date:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {projectDate.toLocaleDateString("en-US", options)}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                PO/SO No:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {projectDetails.po_number}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Project Reference No:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {projectDetails.project_number}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <br />

      <div className="datasheet-row dark-gray">
        <Typography variant="h5" style={{ fontSize:'23px', flex: 1, textAlign: 'center' }}>
          DATASHEET
        </Typography>
      </div>
      <hr />


      <div className="datasheet-row">
        <Grid container spacing={3}>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 80%', fontWeight: 600 }}>
                Fan Model Number:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 20%', textAlign: 'end' }}>
                {d3}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 80%', fontWeight: 600 }}>
                Fan Diameter:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 20%', textAlign: 'end' }}>
                {d1.toFixed(3)}&nbsp;Mtrs
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 80%', fontWeight: 600 }}>
                No of Blades:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 20%', textAlign: 'end' }}>
                {d4}
              </div>
            </div>
          </Grid>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Application:
              </div>
              <div style={{fontSize:'23px', textTransform: 'capitalize' }}>
                {d5}
              </div>
            </div>

            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Mounting Orientation:
              </div>
              <div style={{fontSize:'23px', textTransform: 'capitalize' }}>
                {fanDetails.mounting_orientation}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Installation Type:
              </div>
              <div style={{fontSize:'23px', textTransform: 'capitalize' }}>
                {d7}
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <br />

      <div className="datasheet-row light-gray">
        <Typography variant="h5" style={{ fontSize:'23px', flex: 1, textAlign: 'center' }}>
          OPERATING CONDITIONS
        </Typography>
      </div>
      <div className="datasheet-row">
        <Grid container spacing={3}>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Atmosphere Type:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d10}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Relative Humidity:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d11}&nbsp;%
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Altitude of Installation:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d12}&nbsp;Mtrs
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Barometric Pressure:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d13?.toFixed(2)}&nbsp;kPa
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Density at Design Temperature:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d17}kg/m3
              </div>
            </div>
          </Grid>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Design Ambient Temperature:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d14}°C
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Minimum Temperature:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d15}°C
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Maximum Temperature:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d16}°C
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Density at Min Temp:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d18.toFixed(3)}&nbsp;kg/m3
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Density at Max Temp:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d19.toFixed(3)}&nbsp;kg/m3
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <br />

      <div className="datasheet-row light-gray">
        <Typography variant="h5" style={{ fontSize:'23px', flex: 1, textAlign: 'center' }}>
          APPLICATION SYSTEM DATA
        </Typography>
      </div>
      <div className="datasheet-row">
        <Grid container spacing={3}>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Fan Casing Diameter:
              </div>
              <div style={{ fontSize:'23px'}}>
                {/* {d1.toFixed(3)}&nbsp;Mtr */}
                {/* {(d1 + (d1 * 0.0045 * 2)).toFixed(3)}&nbsp;Mtr */}
                {parseFloat(d2)?.toFixed(2)}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Tip Clearance:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d23.toFixed(2)}MM
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Inlet Shape:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d24}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Inlet L/D:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d27}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Support Beams:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d28}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Drive Efficiency:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d33}%
              </div>
            </div>
          </Grid>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Diffuser Height:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d25}&nbsp;Mtr
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Diffuser Cone Angle:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d26}°
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Motor Power:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d29}&nbsp;kW
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Motor Efficiency:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d32}%
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Motor RPM:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d30}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Motor Classification:
              </div>
              <div style={{ fontSize:'23px'}}>

              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <br />

      <div className="datasheet-row light-gray">
        <Typography variant="h5" style={{ fontSize:'23px', flex: 1, textAlign: 'center' }}>
          PERFORMANCE DATA
        </Typography>
      </div>
      <div className="datasheet-row">
        <Grid container spacing={3}>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Volumetric Airflow Rate:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d34}&nbsp;m3/sec
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                System Static Pressure:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d35?.toFixed(2)}&nbsp;Pa
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Velocity Pressure:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d36.toFixed(2)}&nbsp;Pa
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Velocity Pressure Recovery:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d37 ? d37.toFixed(2) : ''}&nbsp;Pa
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Total Pressure:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d38.toFixed(2)}&nbsp;Pa
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Design Fan Shaft Power:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d39.toFixed(2)}&nbsp;kW
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Fan Shaft Power at Min Density:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d40.toFixed(2)}&nbsp;kW
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Fan Shaft Power at Max Density:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d40_1.toFixed(2)}&nbsp;kW
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Motor Power Consumed:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d70.toFixed(2)}&nbsp;Kw
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Aerodynamic Axial Thrust:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d42.toFixed(2)}&nbsp;kg
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Total Axial Thrust:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d43.toFixed(2)}&nbsp;kg
              </div>
            </div>
          </Grid>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Static Efficiency:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d44.toFixed(2)}%
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Total Efficiency:
              </div>
              <div style={{ fontSize:'23px'}}>
                {parseFloat(d45).toFixed(2)}%
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Average Axial Velocity:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d46.toFixed(2)}&nbsp;m/sec
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Power Per Blade:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d57.toFixed(2)}&nbsp;kW
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Fan RPM:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d49}&nbsp;cycle/min
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Tip Speed:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d50.toFixed(2)}&nbsp;m/s
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Blade Tip Angle:
              </div>
              <div style={{ fontSize:'23px'}}>
                {d51 ? d51.toFixed(2) : d51}°
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Blade Tip Angle (Min):
              </div>
              <div style={{ fontSize:'23px'}}>
                {d52}°
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Blade Tip Angle (Max):
              </div>
              <div style={{ fontSize:'23px'}}>
                {d52_1}°
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Airflow Margin:
              </div>
              <div style={{ fontSize:'23px'}}>
                {(((d47?.airflow) - (fanDetails.req_airflow)) * 100 / fanDetails.req_airflow).toFixed(2)}%
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: 1, fontWeight: 600 }}>
                Pressure Margin:
              </div>
              <div style={{ fontSize:'23px'}}>
                {(((d47?.pressure) - (d38)) * 100 / d38).toFixed(2)}%
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <br />

      <div className="datasheet-row light-gray">
        <Typography variant="h5" style={{ fontSize:'23px', flex: 1, textAlign: 'center' }}>
          MECHANICAL DATA
        </Typography>
      </div>
      <div className="datasheet-row">
        <Grid container spacing={3}>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Total Fan Mass::
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d53.toFixed(2)}&nbsp;kg
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Blade Material:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d54}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Hub material:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d55}
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Torque:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d41.toFixed(2)}&nbsp;kg-m
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                GD2:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d58.toFixed(2)}&nbsp;kg-m2
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Fan Moment of Inertia:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d59.toFixed(2)}&nbsp;kg-m2
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Continuous Unbalance Force:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d60.toFixed(2)}&nbsp;N
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Radial Force due to Failure of 1 blade:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d61.toFixed(2)}&nbsp;N
              </div>
            </div>
          </Grid>
          <Grid item xs={6} lg={6}>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Blade Natural Frequency:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d62}&nbsp;Hz
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Blade Operating Natural Frequency:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d63.toFixed(3)}&nbsp;Hz
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Blade Pass Frequency:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d64.toFixed(2)}&nbsp;Hz
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Bleam Pass Frequency:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d65.toFixed(2)}&nbsp;Hz
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                1 x RPM Frequency:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d66.toFixed(3)}&nbsp;Hz
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Min Resonance Freq Margin:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                %
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Actual Frequency Margin:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                {d67.toFixed(3)}&nbsp;%
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Balancing Class/ Code:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                ISO 10816 - 1 / G-6.3
              </div>
            </div>
            <div className="data-field">
              <div style={{ fontSize:'23px', flex: '1 1 60%', fontWeight: 600 }}>
                Vibration Class/ Code:
              </div>
              <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
                ISO 1940 / 1
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <br />
      <div className="data-footer">
        <hr />
        <div className="data-field">
          <div style={{ fontSize:'23px', flex: '1 1 60%' }}>
            www.encongroup.co.in
          </div>
          <div style={{ fontSize:'23px', flex: '1 1 40%', textAlign: 'end' }}>
            Page 1 of 5
          </div>
        </div>

      </div>

    </Paper>
  );
}
